import EnumClass, { build } from '../EnumClass';
import data, { SiteFeatureId, SiteFeatureData } from './data';
import * as Translations from './translations';

export class SiteFeature extends EnumClass<SiteFeatureId, SiteFeatureData> {
  public get getName() {
    return Translations.name[this.id];
  }

  /**
   * Is there configuration associated with this type of site feature?
   * @returns whether or not there is a configuration model for this site feature.
   */
  public isConfigurable() {
    // The metadata for this enum includes a field for indicating the types of values that
    // may be configured in relation to this feature. Not all site features have conf
    return this.metadata.configuration_model !== null;
  }

  public get isPrivate() {
    return this.metadata.private;
  }
}

export const {
  list: ALL_SITE_FEATURES,
  getById: getSiteFeatureById,
  isId: isSiteFeatureId,
  marshaller: SiteFeatureMarshaller,
  codec: SiteFeatureCodec,
} = build<SiteFeatureId, SiteFeatureData, SiteFeature>('SiteFeatureEnum', data, SiteFeature);

export const PUBLIC_SITE_FEATURES = ALL_SITE_FEATURES.filter(v => !v.isPrivate);
export const PRIVATE_SITE_FEATURES = ALL_SITE_FEATURES.filter(v => v.isPrivate);
